import get from 'lodash/get';
import * as types from './constants';
const defaultState = {
  loading: false,
  error: null,
  activeStep: 0,
  application: {},
  applicationType: '',
  documents: [],
  breakdown: {},
  newMortgageDetails: {},
  lookups: {},
  singlePropertyDetails: {},
  propertyOwners: [],
};
export default function MortgageModificationReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.MORTGAGE_MODIFICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.MORTGAGE_MODIFICATION_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.FETCH_APPLICATION_MORTGAGE_MODIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        applicationType: get(action.payload, 'applicationType', ''),
        contracts: get(action.payload, 'contracts', {}),
        newMortgageDetails: get(action.payload, 'newMortgageDetails', {}),
        fees: get(action.payload, 'fees', {}),
      };

    case types.INITIATE_MORTGAGE_MODIFICATION_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
      };

    case types.ADD_TO_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.CHANGE_MORTGAGE_MODIFICATION_STEP:
      return {
        ...state,
        activeStep: action.payload,
      };

    case types.FETCH_MULTI_PROPERTIES_SUCCESS:
      return {
        ...state,
        loading: false,
        multiProperties: {
          ...action.payload,
          properties: action.payload.properties?.filter(property => !property.isDeleted),
        },
      };

    case types.FETCH_SINGLE_PROPERTY_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        singlePropertyDetails: get(action.payload, 'property', {}),
      };

    case types.FETCH_PROPERTY_OWNERS_SUCCESS:
      return {
        ...state,
        loading: false,
        propertyOwners: get(action.payload, 'propertyOwners', []),
      };

    case types.RELEASE_MORTGAGE_DOCUMENT_RESPONSE:
      return {
        ...state,
        loading: false,
        documents: get(action.payload, 'documents', []),
      };

    case types.STOP_LOADING_WITH_NO_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.FETCH_PAYMENT_BREAKDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        breakdown: get(action.payload, 'breakdown', []),
      };

    case types.CHANGE_FEES_FORM:
      return {
        ...state,
        newMortgageDetails: {
          ...state.newMortgageDetails,
          ...action.payload,
        },
      };

    case types.FETCH_LOOKUPS_START:
      return {
        ...state,
        lookupsLoading: true,
      };

    case types.FETCH_LOOKUPS_SUCCESS:
      return {
        ...state,
        lookupsLoading: false,
        lookups: action.payload,
      };
    case types.FETCH_VALUATOR_LOOKUPS_SUCCESS:
      return {
        ...state,
        lookupsLoading: false,
        lookups: {
          ...state?.lookups,
          valuators: action.payload?.valuators,
        },
      };

    case types.CALCULATE_FEES_SUCCESS:
      return {
        ...state,
        loading: false,
        fees: action.payload,
        isFeesCalculated: true,
      };

    case types.DELETE_PROPERTY_FROM_MORTGAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        multiProperties: {
          ...state.multiProperties,
          recordsTotal: state.multiProperties.recordsTotal - 1,
          properties: state.multiProperties.properties.filter(
            property => property.plotId !== action.payload.propertyId,
          ),
        },
      };
    case types.RESET_MORTGAGE_MODIFICATION_ERROR:
      return {
        ...state,
        error: null,
      };

    case types.RESET_MORTGAGE_MODIFICATION_REDUCER:
      return defaultState;

    case types.FORM_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
}
